// extracted by mini-css-extract-plugin
export default {"upperShieldRoot":"upperShieldRoot____ImoT","kozel":"kozel___tuk6a","s":"s___zud_4","m":"m___s3Xsw","l":"l___lsP1f","upperShieldImg":"upperShieldImg___JlVP7"};